import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type {
  ReportInstance,
  ReportInstanceId,
  ReportInstanceInitializer,
  ReportInstanceMutator,
  ProjectId,
  ReportTemplateId,
} from '@beaded/models'

import { API_BASE_URI } from 'constants/api'

import * as apiUtils from '.'

const url = '/report-instance'

export const get = (
  id: ReportInstanceId,
  options: AxiosRequestConfig = {},
): Promise<{ instance: ReportInstance }> =>
  apiUtils.GET(`${url}/${id}`, options)

export const getAll = (
  options: AxiosRequestConfig = {},
): Promise<{ instances: ReportInstance[] }> => apiUtils.GET(`${url}/`, options)

export const getByProject = (
  projectId: ProjectId,
  options: AxiosRequestConfig = {},
): Promise<{ instances: ReportInstance[] }> =>
  apiUtils.GET(`${url}/`, merge({ params: { projectId } }, options))

export const getByTemplate = (
  templateId: ReportTemplateId,
  options: AxiosRequestConfig = {},
): Promise<{ instances: ReportInstance[] }> =>
  apiUtils.GET(`${url}/`, merge({ params: { templateId } }, options))

export const create = (data: ReportInstanceInitializer) =>
  apiUtils.POST(`${url}/`, data)

export const update = (id: ReportInstanceId, data: ReportInstanceMutator) =>
  apiUtils.PUT(`${url}/${id}`, data)

export const remove = (id: ReportInstanceId) => apiUtils.DELETE(`${url}/${id}`)

export const download = (id: ReportInstanceId) => {
  window.open(`${API_BASE_URI()}/report-instance/${id}/download`, '_blank')
}
